<template>
  <div>
    <el-popover
      placement="top"
      width="400"
      :trigger="trigger"
      :open-delay="openDelay"
      :disabled="truncatedText.length === text.length"
    >
      <span
        slot="reference"
      >
        {{ truncatedText }}
        </span>
      <div v-html="text"></div>
    </el-popover>
  </div>
</template>

<script>
export default {
  name: "collapse-text-with-tooltip",
  props: {
    trigger: {
      type: String,
      default: 'hover'
    },
    text: {
      type: String|null,
      required: true,
      default: ''
    },
    maxLength: {
      type: Number,
      default: 20
    },
    openDelay: {
      type: Number,
      default: 0
    }
  },
  computed: {
    truncatedText() {
      if (this.text && this.text.length > this.maxLength) {
        return this.text.slice(0, this.maxLength) + "...";
      }
      return this.text ?? '';
    }
  }
};
</script>

<style scoped>

</style>